import { Component, EventEmitter, inject, Input, Output, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth.service';
import { AiRestrictedHoverDirective } from 'src/app/shared/directives/ai-restricted-hover.directive';

@Component({
  selector: 'app-generate-content',
  template: `
    <input type="file" #fileInput style="display: none" (change)="openAiContentPane()" />

    @switch (displayMode) {
      @case ('interactive') {
        <div
          class="interactive-item"
          [class.disabled]="!canUseAI"
          (click)="openAiContentPane()"
          [matTooltip]="(canUseAI ? itemText : 'GenerateContent.NoAiAccessTooltip') | translate"
          [appAiRestrictedHover]="!canUseAI"
        >
          <div class="interactive-item__content">
            <div class="interactive-item__prefix"></div>
            <mat-icon class="interactive-item__icon" aria-hidden="true">{{ itemIcon }}</mat-icon>
            <span class="interactive-item__text">{{ (canUseAI ? itemText : 'GenerateContent.NoAiAccess') | translate }}</span>
          </div>
        </div>
      }
      @case ('icon') {
        <span [matTooltip]="(canUseAI ? itemText : 'GenerateContent.NoAiAccessTooltip') | translate" [appAiRestrictedHover]="!canUseAI">
          <button mat-icon-button btnType="action-icon" (click)="openAiContentPane()" [disabled]="!canUseAI || disabled()">
            <mat-icon>{{ itemIcon }}</mat-icon>
          </button>
        </span>
      }
    }
  `,
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, TranslateModule, AiRestrictedHoverDirective],
})
export class GenerateContentComponent {
  disabled = input(false);
  @Input() displayMode: 'interactive' | 'icon' = 'interactive';
  @Output() clicked = new EventEmitter<boolean>();

  itemText = 'Courses.ChunkCreator.GenerateWithAI';
  itemIcon = 'smart_toy';

  private authService = inject(AuthService);
  canUseAI = this.authService.canUseAI();

  openAiContentPane(): void {
    if (!this.canUseAI) return;
    this.clicked.emit(true);
  }
}
